import { createStore } from "redux";
import reducer from "../testReducers";

const initialState = { payload: {} };
export const store = createStore(reducer, initialState);